/** @flow */
import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchCustomers } from '../../customers/actions/customersActions';
import { getCustomers, isFetchingCustomers, hasError } from '../../customers/selectors/customerSelectors';
import AddCustomerDialog from '../../customers/components/AddCustomerDialog';
import RadioCustomer from '../types/RadioCustomer';

const DropDownWrapper = styled.div`
  min-width: 200px;
  margin-top: ${({ theme }) => theme.metrics.smallMargin}px;
  display: flex;
  align-items: center;
`;

const CreateCustomerText = styled.div`
  font-size: ${({ theme }) => theme.fonts.style.midSmall.fontSize}px;
  text-decoration: underline;
  cursor: pointer;
  margin-top: ${({ theme, withMargin }) => (withMargin ? theme.metrics.largeMargin : 0)}px;
`;

type Props = {
  value: string;

  customers: RadioCustomer[];
  error: boolean;
  fetching: boolean;
  customerError: string;
  disabled?: boolean;
  fullWidth?: boolean;
  wrapperStyle?: Object;

  actions: {
    fetchCustomers: () => any,
  };

  onCustomerChanged: (RadioCustomer) => void;
  inviteCustomer: boolean;

  t: any;
}

type State = {
  radioCustomer: ?RadioCustomer;
  showAddCustomerDialog: boolean;
}

class CustomerSelect extends Component<Props, State> {
  state = {
    radioCustomer: undefined,
    showAddCustomerDialog: false,
  };

  getCustomersAsItems = (): Object[] => {
    return this.props.customers.map(customer => ({
      label: `${customer.getAdvertiserName()} (${customer.getContactFullName()})`,
      value: customer.getReference(),
    })).sort();
  };

  onCustomerChanged = (newReference: string) => {
    const customer = this.props.customers.find(c => c.hasReference(newReference));
    if (!customer) {
      return;
    }

    this.props.onCustomerChanged(customer);
  };

  onOpenAddCustomerDialog = () => {
    this.setState({ showAddCustomerDialog: true });
  };

  onCloseAddCustomerDialog = (customer?: RadioCustomer) => {
    this.setState((prevState) => {
      return {
        showAddCustomerDialog: false,
        radioCustomer: customer || prevState.radioCustomer,
      };
    });
  };

  componentWillMount() {
    if (!this.props.fetching) {
      this.props.actions.fetchCustomers();
    }
  }

  render() {
    const { t, customerError, disabled, fullWidth, wrapperStyle } = this.props;

    return (
      <div style={wrapperStyle}>
        <DropDownWrapper>
          <SelectField
            disabled={disabled}
            value={this.props.value}
            onChange={(event, index, value) => this.onCustomerChanged(value)}
            errorText={customerError}
            fullWidth={fullWidth || false}
          >
            {this.getCustomersAsItems()
              .map(item =>
                <MenuItem
                  key={item.value}
                  primaryText={item.label}
                  value={item.value}
                />)}
          </SelectField>
        </DropDownWrapper>
        {this.props.inviteCustomer &&
        <CreateCustomerText withMargin={Boolean(customerError)} onClick={this.onOpenAddCustomerDialog}>{t('customers:createACustomer')} +</CreateCustomerText>
        }

        {this.props.inviteCustomer &&
        <AddCustomerDialog visible={this.state.showAddCustomerDialog} onClose={customer => this.onCloseAddCustomerDialog(customer)} />
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    customers: getCustomers(state),
    error: hasError(state),
    fetching: isFetchingCustomers(state),
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ fetchCustomers }, dispatch),
  };
}

export default translate('sales', 'customers')(withTheme(connect(mapStateToProps, mapDispatchToProps)(CustomerSelect)));



// WEBPACK FOOTER //
// ./src/statsradio/modules/customers/components/CustomerSelect.js